import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { parse, stringify } from '../utils/UrlUtil';

/**
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isNaN
 * @param {*} num
 */
function isNumeric(num) {
  // eslint-disable-next-line no-restricted-globals
  return !isNaN(num);
}

/**
 * Returns the page size.
 * - value of `first` if it is a number
 * - value of `last` if `first` is not a number
 * - `defaultPageSize` if both are not numbers
 * @param {*} param0
 * @param {*} defaultPageSize
 */
function getPageSize({ first, last }, defaultPageSize) {
  if (isNumeric(first)) {
    return first;
  }
  if (isNumeric(last)) {
    return last;
  }

  return defaultPageSize;
}

/**
 * Displays a paginator for DataTables.
 * Inspired by https://www.primefaces.org/primereact/#/paginator
 */
class Paginator extends Component {
  static propTypes = {
    pageInfo: PropTypes.shape({
      hasPreviousPage: PropTypes.bool,
      hasNextPage: PropTypes.bool,
      startCursor: PropTypes.string,
      endCursor: PropTypes.string,
    }).isRequired,
    totalCount: PropTypes.number.isRequired,
    indexFrom: PropTypes.number,
    indexTo: PropTypes.number,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
    defaultPageSize: PropTypes.number,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  static defaultProps = {
    rowsPerPageOptions: [25, 50, 100],
    indexFrom: 0,
    indexTo: 0,
    defaultPageSize: 25,
  };

  constructor(props) {
    super(props);
    this.onPageSizeChange = this.onPageSizeChange.bind(this);
  }

  onPageSizeChange(event) {
    const { history, location } = this.props;

    const params = parse(location.search);

    history.push({
      ...location,
      search: stringify({
        ...params,
        first: event.value,
        before: undefined,
        last: undefined,
      }),
    });
  }

  render() {
    const {
      pageInfo, totalCount, indexFrom, indexTo, location, rowsPerPageOptions, defaultPageSize,
    } = this.props;
    const {
      hasPreviousPage, hasNextPage, startCursor, endCursor,
    } = pageInfo;

    const rowsPerPage = rowsPerPageOptions.map(value => ({ label: value, value }));
    const params = parse(location.search);
    const pageSize = getPageSize(params, defaultPageSize);

    const prevLink = {
      ...location,
      search: stringify({
        ...params,
        last: pageSize,
        before: startCursor,
        first: undefined,
        after: undefined,
      }),
    };

    const nextLink = {
      ...location,
      search: stringify({
        ...params,
        first: pageSize,
        after: endCursor,
        before: undefined,
        last: undefined,
      }),
    };

    return (
      <div>
        <Link to={hasPreviousPage ? prevLink : location}>
          <Button icon="pi pi-caret-left" disabled={!hasPreviousPage} />
        </Link>
        <span>{` ${indexFrom} - ${indexTo} / ${totalCount} `}</span>
        <Link to={hasNextPage ? nextLink : location}>
          <Button icon="pi pi-caret-right" disabled={!hasNextPage} />
        </Link>
        <Dropdown value={parseInt(pageSize, 10)} options={rowsPerPage} onChange={this.onPageSizeChange} />
      </div>
    );
  }
}

export default withRouter(Paginator);
